<span>
  <button (click)="onDownloadClicked()" mat-icon-button [matTooltip]="'SHARED.DOCUMENT_ATTACHMENTS.DOWNLOAD.TOOLTIP' | translate">
    <mat-icon>download</mat-icon>
  </button>
  @if (!isReadOnly) {
    <button (click)="onDeleteClicked()" mat-icon-button [matTooltip]="'SHARED.DOCUMENT_ATTACHMENTS.DELETE.TOOLTIP' | translate">
      <mat-icon>delete</mat-icon>
    </button>
  }
</span>
